/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_More_ActionsInputs */



/**
* | output |
* | --- |
* | "More actions" |
*
* @param {Assistant_More_ActionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_more_actions = /** @type {((inputs?: Assistant_More_ActionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_More_ActionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus d'actions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Aktionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altre azioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дополнительные действия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más acciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更多操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("その他の操作")
	if (locale === "hi") return /** @type {LocalizedString} */ ("और कार्रवाइयां")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mais ações")
	return /** @type {LocalizedString} */ ("More actions")
});